module.exports = __webpack_public_path__ + "static/media/profitroom.a993ed8a.ico";